(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lunoax-model-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lx-model-view')) {
    customElements.define('lx-model-view', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        const { signal } = this.controller;
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('.lx-model-open');
        const track = this.querySelector('.lx-model-track');

        if (!dialog || !opener || !track) return;

        opener.addEventListener('click', () => {
          if (!dialog.open) dialog.showModal();
        }, { signal });

        this.querySelector('.lx-model-close').addEventListener(
          'click',
          () => dialog.close(),
          { signal }
        );

        this.querySelectorAll('[data-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const reduced = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

            track.scrollBy({
              left: Number(button.dataset.step) * track.clientWidth,
              behavior: reduced ? 'instant' : 'smooth'
            });
          }, { signal });
        });

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;

          const r = dialog.getBoundingClientRect();

          if (
            event.clientX < r.left ||
            event.clientX > r.right ||
            event.clientY < r.top ||
            event.clientY > r.bottom
          ) {
            dialog.close();
          }
        }, { signal });

        dialog.addEventListener('close', () => {
          opener.focus({ preventScroll: true });
        }, { signal });
      }

      disconnectedCallback() {
        this.querySelector('dialog')?.close();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lunoax-rail')) {
    customElements.define('lunoax-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.lx-rail-track');
        this.items = [...this.querySelectorAll('.lx-rail-item')];
        if (!this.track || !this.items.length) return;

        const reduced = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        const center = (item) => {
          const left =
            item.offsetLeft -
            this.track.offsetLeft -
            (this.track.clientWidth - item.clientWidth) / 2;

          this.track.scrollTo({
            left,
            behavior: reduced.matches ? 'auto' : 'smooth'
          });
        };

        const paint = () => {
          const bounds = this.track.getBoundingClientRect();
          const middle = bounds.left + bounds.width / 2;

          for (const item of this.items) {
            const rect = item.getBoundingClientRect();
            const distance = Math.max(-1, Math.min(
              1,
              (rect.left + rect.width / 2 - middle) /
                Math.max(1, bounds.width / 2)
            ));

            item.style.setProperty(
              '--lx-turn', `${distance * -28}deg`
            );
            item.style.setProperty(
              '--lx-scale', `${1 - Math.abs(distance) * 0.25}`
            );
            item.style.setProperty(
              '--lx-opacity', `${1 - Math.abs(distance) * 0.25}`
            );
          }
        };

        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(paint);
        };

        this.track.addEventListener('scroll', schedule, {
          passive: true, signal
        });

        this.items.forEach((item) => {
          item.addEventListener('click', () => {
            if (!this.dragged) center(item);
          }, { signal });
        });

        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();

          const bounds = this.track.getBoundingClientRect();
          const middle = bounds.left + bounds.width / 2;
          let nearest = 0;
          let gap = Infinity;

          this.items.forEach((item, index) => {
            const rect = item.getBoundingClientRect();
            const value = Math.abs(
              rect.left + rect.width / 2 - middle
            );
            if (value < gap) {
              gap = value;
              nearest = index;
            }
          });

          const step = event.key === 'ArrowRight' ? 1 : -1;
          center(this.items[Math.max(
            0, Math.min(this.items.length - 1, nearest + step)
          )]);
        }, { signal });

        this.track.addEventListener('pointerdown', (event) => {
          this.dragged = false;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.pointer = event.pointerId;
        }, { signal });

        this.track.addEventListener('pointermove', (event) => {
          if (this.pointer !== event.pointerId) return;
          const move = event.clientX - this.startX;

          if (Math.abs(move) > 6 && !this.dragged) {
            this.dragged = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.style.scrollSnapType = 'none';
          }

          if (this.dragged) {
            this.track.scrollLeft = this.startScroll - move;
          }
        }, { signal });

        const release = () => {
          this.pointer = undefined;
          this.track.style.scrollSnapType = '';
        };

        this.track.addEventListener('pointerup', release, { signal });
        this.track.addEventListener('pointercancel', release, { signal });
        this.track.addEventListener('lostpointercapture', release, { signal });
        this.track.addEventListener('dragstart', (event) => {
          event.preventDefault();
        }, { signal });

        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this.track);
        schedule();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
